<div
  [class.linear]="form === forms.LINEAR"
  [class.arc]="form === forms.ARC"
  [ngStyle]="form === forms.CIRCULAR || form === forms.ARC ? { 'width.px': diameter, 'height.px': diameter } : {}"
  [matTooltip]="tooltip"
  data-cy="ui-progress-container"
  class="ui-progress__container"
  >
  @if (form === forms.CIRCULAR) {
    <mat-progress-spinner
      [diameter]="diameter"
      [mode]="mode"
      [value]="percentage"
      data-cy="ui-progress-spinner"
      >
    </mat-progress-spinner>
  }

  <!--
  Ghost element needed,
  because mat-progress-spinner has no .mat-progress-spinner-background
  Fix one to 100% and position above each-other
  -->
  @if (form === forms.CIRCULAR && mode === modes.DETERMINATE) {
    <mat-progress-spinner
      [diameter]="diameter"
      value="100"
      class="ui-progress__circular__ghost"
      data-cy="ui-progress-ghost-spinner"
      >
    </mat-progress-spinner>
  }

  @if (form === forms.LINEAR) {
    <mat-progress-bar
      [value]="invertedPercentage"
      [mode]="mode"
      data-cy="progress-bar"
      class="success"
    ></mat-progress-bar>
  }

  @if (form == forms.ARC) {
    <div class="ui-progress__arc" data-cy="progress-arc">
      <svg viewBox="0 0 100 100" [attr.width]="diameter" [attr.height]="diameter">
        <linearGradient id="ui-progress__arc-gradient">
          <stop class="start" offset="0" />
          <stop class="stop" offset="1" />
        </linearGradient>
        <path class="ui-progress__arc-track ui-progress__arc-ghost" d="M20,90 A40,40 0 1,1 80,90" />
        <path
          class="ui-progress__arc-track ui-progress__arc-progress"
          d="M20,90 A40,40 0 1,1 80,90"
          [style.stroke-dashoffset]="(183.5 / 100) * invertedPercentage"
          />
      </svg>
      @if (svgIcon) {
        <campus-icon [svgIcon]="svgIcon" class="ui-caption ui-progress__arc-icon"></campus-icon>
      }
      <span class="ui-caption ui-progress__arc-label" data-cy="ui-progress__arc-label">
        <span class="ui-progress__arc-amount" data-cy="progress-arc-amount">{{ count }}</span>
        <span class="ui-progress__arc-total" data-cy="progress-arc-total">/{{ total }}</span>
      </span>
    </div>
  }

  @if (showPercentage && !(completedIcon && percentage === 100)) {
    <span
      [@fadeLabel]
      class="ui-caption ui-progress__label"
      data-cy="ui-progress-percentage-label"
      >{{ percentage }}%{{ percentageSuffix ? ' ' + percentageSuffix : '' }}</span
      >
    }
    @if (form === forms.CIRCULAR && completedIcon && percentage === 100) {
      <div
        [@explodeIcon]
        class="ui-progress__completed-icon ui-progress__label"
        data-cy="ui-progress-completed-icon"
        ><ng-content select="[campusCompletedProgressIcon], [completedProgressIcon], completed-progress-icon"></ng-content
      ></div>
    }
  </div>
